import { ITenant } from '../App';
import { get } from '../api/api';
import { uriGetFunctionalities } from '../api/endpoints';
import {
  generateFuncObjectWithoutLabels,
  updateStringFeatureWithLabels,
} from '../util/utility';
import { strings } from '../util/strings';
import { Store } from '../store';

export const getBuFunctionalities = async (
  buAlias: string,
  language: string,
  featureName?: string
) => {
  return await get(uriGetFunctionalities(buAlias), false, 0, featureName)
    .then((response: any) => {
      return {
        funcionalidade: response?.data?.items || response,
        buId: buAlias,
      };
    })
    .catch((e: any) => {
      console.log('Error loading ', buAlias, ' functionalities:', e);
    });
};

const getValuesToStoreWithBuDataFromGraphql = async (
  userProfile: any,
  selectedBu: any,
  busMap: any,
  tenant: ITenant,
  defaultLanguage: string,
  language?: string,
  featureName?: string
) => {
  let busFunctionalities: any = [];

  if (selectedBu.buId === 'NOTCLIENT') {
    busMap = [];
    const notClientFunctionalities = await get(
      uriGetFunctionalities('NOTCLIENT'), false, 0, featureName
    ).then((response: any) => ({
      funcionalidade: response?.data?.items || response,
      buId: 'NOTCLIENT',
    }));
    busFunctionalities.push(notClientFunctionalities);
  } else {
    busFunctionalities = await Promise.all(
      Object.keys(busMap).map((key) =>
        getBuFunctionalities(
          key,
          language || userProfile.language || defaultLanguage || 'pt-PT',
          featureName
        )
      )
    );
  }

  const currentBuFunctionalities = busFunctionalities.filter(
    (func: any) => func?.buId === selectedBu?.buId
  )[0].funcionalidade;

  let stringsToState = { ...strings, ...Store.getState()?.strings?.value };

  const stringsToStore = updateStringFeatureWithLabels(
    stringsToState,
    currentBuFunctionalities
  );

  const funcDefaultObject = generateFuncObjectWithoutLabels(busFunctionalities);

  return {
    busMap,
    busFunctionalities,
    stringsToStore,
    funcDefaultObject,
  };
};

export default getValuesToStoreWithBuDataFromGraphql;
